GeoJSONLayer = App.loadClass 'grower::handlers/data/GeoJSON_Layer'

class exports.Layer_Shapefile_GeoJSON extends GeoJSONLayer
    constructor: () ->
        super()
        @fetchUrl = 'backend/grower/layers/shapefile/get-json'

    # Sliders are now being handled by the mfSlider directive
    # initSlider: () ->
    #     @slider = @parent.sidebar_row.find('.shapefile-slider')

